import React, { useEffect, useState } from "react";
import { Form, Row } from "react-bootstrap";
import { useIntl } from "react-intl";
import CardNew from "components/molecules/Card/CardNew";
import ReactHtmlParser from "react-html-parser";
import PropTypes from "prop-types";
import { ReactComponent as SubmitIcon } from "assets/images/icons/SubmitIcon.svg";
import errorToast from "helpers/errorToast";
import Button from "components/atoms/Button/Button";
import "./customField.scss";
import { updateCustomLongfield01 } from "api";
import testIds from "constants/testIds";
import { replaceLinks } from "helpers/urlHelpers";
import { replaceLinebreaks } from "helpers/commonHelpers";
import getLabel from "helpers/getLabel";

const customField = function ({ shipmentId, loadingData, quotesData, status, userType }) {
  const intl = useIntl();
  const [manageCustomField, setManageCustomField] = useState(false);
  const [customLongField, setCustomLongField] = useState("");

  const handleChange = (e) => {
    setCustomLongField(e.target.value);
  };

  const handleEdit = () => {
    setManageCustomField(true);
  };

  const handleDiscardChanges = () => {
    setCustomLongField(quotesData?.organization?.custom_longfield_01 || quotesData?.organization?.custom_longfield1);
    setManageCustomField(false);
  };

  const handleSaveChanges = () => {
    setManageCustomField(false);
    const payload = {
      custom_longfield1: customLongField,
    };
    updateCustomLongfield01(shipmentId, payload)
      .then((res) => setCustomLongField(res.data?.custom_longfield1))
      .catch((error) => errorToast(error));
  };

  useEffect(() => {
    setCustomLongField(quotesData?.organization?.custom_longfield_01 || quotesData?.organization?.custom_longfield1);
  }, [quotesData]);

  if (status !== 200) return null;

  return (
    <CardNew className="position-relative" height="280px" isLoading={loadingData} loadingSkeletonRowCount={2}>
      {userType !== "provider" && (
        <>
          {!manageCustomField && (
            <SubmitIcon
              className="text-secondary font-12 cursor-pointer"
              onClick={handleEdit}
              data-testid={testIds.SHIPMENT_DASHBOARD_EDIT_CUSTOM_LONGFIELD_BUTTON}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
              }}
            />
          )}
        </>
      )}
      <CardNew.Body className="p-0">
        <div className="d-flex justify-content-center align-items-center">
          <h5>{getLabel("Custom longfield 01", "capitalize", quotesData?.organization?.payment_location_reference)}</h5>
        </div>
        <Form className="w-100">
          <Form.Group>
            {!manageCustomField ? (
              <div className="d-flex justify-content-between text-wrap mt-3 font-b3">
                <div style={{ maxHeight: "200px", width: "100%", overflowY: "auto" }}>
                  {ReactHtmlParser(replaceLinebreaks(replaceLinks(customLongField || "No Records Found")))}
                </div>
              </div>
            ) : (
              <>
                <Form.Control
                  as="textarea"
                  name="custom_long_field"
                  value={customLongField}
                  onChange={(e) => handleChange(e)}
                  rows={8}
                  style={{
                    border: "1px solid black",
                    borderRadius: "12px",
                  }}
                />
                <div className="pt-3 d-flex justify-content-between" style={{ marginTop: "15px" }}>
                  <Button
                    variant="outline-primary"
                    type="submit"
                    label={intl.formatMessage({
                      id: "general.cancel",
                      defaultMessage: "Cancel",
                    })}
                    onClick={handleDiscardChanges}
                  />
                  <Button
                    variant="primary"
                    type="submit"
                    label={intl.formatMessage({
                      id: "general.saveChanges",
                      defaultMessage: "Save changes",
                    })}
                    onClick={handleSaveChanges}
                    data-testids={testIds.SHIPMENT_DASHBOARD_EDIT_CUSTOM_LONGFIELD_CONFIRM_BUTTON}
                  />
                </div>
              </>
            )}
          </Form.Group>
          <Row as={Form.Group} className="mb-0" />
        </Form>
      </CardNew.Body>
    </CardNew>
  );
};

customField.propTypes = {
  shipmentId: PropTypes.string.isRequired,
  loadingData: PropTypes.bool.isRequired,
  quotesData: PropTypes.instanceOf(Object),
  userType: PropTypes.string,
};

customField.defaultProps = {
  quotesData: null,
  userType: "",
};

export default customField;
